/**
 * Created by Bob.Gear on 11/03/14.
 */
//------------------------------------------------------------------------
//  contractTypeFilter Directive
//------------------------------------------------------------------------
angular.module("EICDataStream3.queryBuilder")
    .controller('offshoreWindFoundationTypeFilterController',
        [
            '$scope', 'lookupTables',
            function($scope, lookupTables) {
                $scope.componentName = "offshoreWindFoundationTypeFilter";

                $scope.resetFilter = function() {
                    $scope.clearSelections();
                };

                $scope.clearSelections = function() {
                    delete $scope.criteria["offshoreWindFoundationType"];
                    delete $scope.criteria["includeUndetermined"];
                };

                $scope.removeFilter = function() {
                    $scope.resetFilter();
                    $scope.$parent.removeFilter("#offshoreWindFoundationTypeFilter");
                };

            }
        ])
    .directive('offshoreWindFoundationTypeFilter',
        [
            '$compile',
            function($compile) {
                return {
                    replace: true, // replace the placeholder element with the template
                    restrict: 'A', // usage: <div projectNameFilter />
                    templateUrl: "../app-ds3/search/queryBuilder/filters/offshoreWindFoundationTypeFilter.tmpl.html",

                    link: function($scope, iElement, iAttrs) {
                    },

                    controller: 'offshoreWindFoundationTypeFilterController'
                };
            }
        ]);
//------------------------------------------------------------------------
